import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { API_BASE_URL } from "./api-base";

export interface SubmissionResult {
  submissionId: number;
  status: string;
  output: string;
  failedTests: string[];
  executionTime: number | null;
  passed?: number;
  total?: number;
  unlockedLevel?: {
    id: number;
    levelNumber: number;
    title: string;
  } | null;
  rewards?: {
    gainedXp: number;
    streak: number;
    level: number;
    achievements: string[];
  } | null;
}

@Injectable({ providedIn: "root" })
export class SubmissionService {
  constructor(private readonly http: HttpClient) {}

  run(problemId: number, code: string, options?: { mode?: "practice" | "challenge" | "contest"; customInput?: string }) {
    return this.http.post<SubmissionResult>(`${API_BASE_URL}/submissions/run`, {
      problemId,
      code,
      mode: options?.mode || "practice",
      customInput: options?.customInput || ""
    });
  }

  submit(
    problemId: number,
    code: string,
    options?: { mode?: "practice" | "challenge" | "contest"; contestId?: string | null }
  ) {
    const payload: {
      problemId: number;
      code: string;
      mode: "practice" | "challenge" | "contest";
      contestId?: string;
    } = {
      problemId,
      code,
      mode: options?.mode || "practice"
    };

    if (options?.contestId) {
      payload.contestId = options.contestId;
    }

    return this.http.post<SubmissionResult>(`${API_BASE_URL}/submissions/submit`, payload);
  }

  getRecent() {
    return this.http.get<
      Array<{
        id: number;
        problemId: number;
        problemTitle: string;
        status: string;
        executionTime: number | null;
        createdAt: string;
      }>
    >(`${API_BASE_URL}/submissions/me`);
  }
}
